var widget_default = {
  "card": "HX8PN",
  "link": "Co3DE",
  "container": "O-XR3",
  "image": "_7M-RO",
  "right": "AYTQp",
  "cardLayout": "faAnV",
  "content": "rM5VM",
  "title": "yiun8",
  "subtitle": "jdZ4d",
  "button": "R9nKP",
  "button_disabled": "lHX61",
  "buttonText": "oRMIj",
  "slimLayout": "_3BrQD",
  "contentText": "-AkIc"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
